import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/App";
import { initials } from "@/lib/api";

export default function Navbar({ onShare, onTopic }) {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [searchParams] = useSearchParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchVal, setSearchVal] = useState(searchParams.get("q") || "");
  const wrapRef = useRef(null);

  useEffect(() => {
    setSearchVal(searchParams.get("q") || "");
  }, [searchParams]);

  useEffect(() => {
    const onClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  const submitSearch = (e) => {
    e?.preventDefault?.();
    const q = searchVal.trim();
    navigate(q ? `/?q=${encodeURIComponent(q)}` : "/");
  };

  // Live search: navigate to /?q= as the user types (debounced)
  useEffect(() => {
    const handle = setTimeout(() => {
      const cur = searchParams.get("q") || "";
      const next = searchVal.trim();
      if (next === cur) return;
      if (next.length === 0) {
        if (cur) navigate("/");
        return;
      }
      navigate(`/?q=${encodeURIComponent(next)}`);
    }, 280);
    return () => clearTimeout(handle);
  }, [searchVal]); // eslint-disable-line

  const isOn = (path) => loc.pathname === path;

  return (
    <div className="fnav">
      <div className="fnav-i">
        <div className="logo" data-testid="nav-logo" onClick={()=>navigate("/")}>
          <strong>LANTEN</strong> <em>forum</em>
        </div>
        <form className="nav-search" onSubmit={submitSearch}>
          <button type="submit" className="nav-si" data-testid="nav-search-btn"
                  style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)",
                          background:"transparent",border:"none",cursor:"pointer",padding:0,color:"var(--ink4)",fontSize:13}}
                  aria-label="Search">🔍</button>
          <input data-testid="nav-search" placeholder="Search stories, tags, cities…"
                 value={searchVal}
                 onChange={(e)=>setSearchVal(e.target.value)} />
        </form>
        <div className="nav-links">
          <div className={`nvl ${isOn("/")?"on":""}`} data-testid="nav-forum" onClick={()=>navigate("/")}>Forum</div>
          <div className={`nvl ${loc.pathname.startsWith("/reads")?"on":""}`} data-testid="nav-reads" onClick={()=>navigate("/reads")}>Reads</div>
          <div className={`nvl ${isOn("/contact")?"on":""}`} data-testid="nav-contact" onClick={()=>navigate("/contact")}>Contact</div>
          <div className={`nvl ${isOn("/admin")?"on":""}`} data-testid="nav-mod-login"
               style={{color:"#C47E2B",fontWeight:600,display:"flex",alignItems:"center",gap:4}}
               onClick={()=>navigate("/admin")}>
            <span style={{fontSize:11}}>🛡️</span> Moderator
          </div>
        </div>
        <div className="nvsep" />
        <div className="nav-btns">
          {user ? (
            <>
              <button className="btn-topic" data-testid="nav-start-topic" onClick={onTopic}>+ Start Topic</button>
              <button className="btn-story" data-testid="nav-share-story" onClick={onShare}>+ Share Story</button>
              <div ref={wrapRef} style={{position:"relative"}}>
                <div className="uchip" data-testid="nav-user-chip" onClick={(e)=>{e.stopPropagation(); setMenuOpen(v=>!v);}}>
                  <div className="uchip-av">{initials(user.real_name || user.name)}</div>
                  <span className="uchip-name">{user.username || user.real_name || user.name}</span>
                </div>
                {menuOpen && (
                  <div className="user-menu">
                    <div className="um-item" data-testid="menu-profile" onClick={()=>{setMenuOpen(false); navigate("/profile");}}>Edit profile</div>
                    <div className="um-sep" />
                    <div className="um-item" data-testid="menu-logout" onClick={async()=>{setMenuOpen(false); await logout(); navigate("/");}}>Sign out</div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <button className="btn-dark" data-testid="nav-signup-btn" onClick={login}>Join LanTen</button>
          )}
        </div>
      </div>
    </div>
  );
}
